import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import thunk from 'redux-thunk';
import { loadUser } from 'redux-oidc';
import { OidcProvider, processSilentRenew } from 'redux-oidc';

//import createBrowserHistory from 'history/createBrowserHistory';

import reducers from './reducers';
import userManager from './userManager';

import { IsKD_Inventario, SetKD } from './KDgeneric';

//
// Al cargar el userManager detecta si viene de la página de Login de KD (mirando
// si el pathname es algo tan raro como "/5428c27d-ed70-4086-baf2-600e9c6a5921") y
// entonces le asigna un cliente de IdentityServer tal que al volver vaya aun callback
// (callback_page_kd) tal que al volver de identificar al usuario no vaya a una página
// de ilusiona sino a una página en blanco (lo ideal sería que se cerrara pero no sé cómo) 
//
// A partir de ahí, cuando entre de nuevo en esta página desde el iframe, el usuario ya estará 
// en el navegador,  no irá a IdentityServer y además tendra ya un window.location.ancestorOrigins[]
// con el que identificar que viene de KD y de cuál viene.
// 
const createStoreWithMiddleware = applyMiddleware(ReduxPromise, thunk)(createStore);
const store = createStoreWithMiddleware(reducers);

loadUser(store, userManager);

if ( IsKD_Inventario() ) SetKD();

//export const history = createBrowserHistory();

if (window.location.pathname === '/silent_renew.html') {
    console.log('renew');
    processSilentRenew();
}
else {
    ReactDOM.render(
        <Provider store={store}>
            <OidcProvider store={store} userManager={userManager}>
                <App />
            </OidcProvider>
        </Provider>, document.getElementById('root')
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
